import HCLDX from "@system/config/hcldx";
// import System from "src/helper/system";
import Helper from "../../src/support/Helper";
// const c = System.getParams();

class Cart {
  static CART_COUNT = Helper.getCartUrl() + "/api/cart/count";
  static ADD_TO_CART = Helper.getCartUrl() + "/api/cart/addItem";
  static ADD_TO_CART_IN_BULK = Helper.getCartUrl() + "/api/cart/addItems";
  static UPDATE_TO_CART = Helper.getCartUrl() + "/api/cart/update";
  static UPDATE_BACKORDER_QUANTITY_TO_CART = Helper.getCartUrl() + "/api/cart/orderItemUpdate";
  static VIEW_CART = Helper.getCartUrl() + "/api/cart/view";
  static VALIDATE_CART = Helper.getCartUrl() + "/api/cart/validate";
  static COMPLETELY_CLEAR_CART = Helper.getCartUrl() + "/api/cart/clear";
  static CLEAR_SINGLE_PRODUCT_FROM_CART = Helper.getCartUrl() + "/api/cart/deleteItem";
  static SCHEDULE_SHIPPING_APPLY = Helper.getCartUrl() + "/api/scheduleShipping/apply";
  static EXPORT_CART_DATA = Helper.getCartUrl() + "/api/cart/exportCart";
  // static GET_VAT_DATA = Helper.getVatUrl() + "/api/vat/check";
  static VALIDATE_TO_SHIP = Helper.getApplicationUrl() + "/api/application/validatetoship";
  static CHECK_CART_ITEM_EXIST = Helper.getCartUrl() + "/api/cart/checkItemsExists";
  static REPLACE_TO_CART_IN_BULK = Helper.getCartUrl() + "/api/cart/moveToCart";
  /**
   * UPDATE_CART_ITEMS_BULK temporary comment due to cart issue need for optimize update cart call
   * Author: Devanshi Patel
   */
  static UPDATE_CART_ITEMS_BULK = Helper.getCartUrl() + '/api/cart/updateitems';
  static CHECK_ITEM_FOR_BLACKLIST_COUNTRY = Helper.getCartUrl() + '/api/cart/checkItemsForVendorExclusion';
  static CHECKOUT_CHARGE = Helper.getCartUrl() + '/api/cart/invoice/getAmount';
  // static getCartPageRouteURL() {
  //   const quoteNumber = c.quote_number;
  //   if (!quoteNumber) {
  //     return HCLDX.baseURL() + "/shop/cart";
  //   } else return HCLDX.baseURL() + "/shop/quote-cart";

  //   // return HCLDX.baseURL() + '/shop/cart';
  // }
  static getCartPageRouteURL() {
    return HCLDX.baseURL() + '/shop/cart';
  }
  static getQuoteCartPageRouteURL() {
    return HCLDX.baseURL() + "/shop/quote-cart";
  }

  static getCartPagePlainRouteURL() {
    return "/shop/cart";
  }
}

export default Cart;
